import { QuestDefinition } from './types';

/**
 * Quest definition for the Line Detection tool (LineTool / 'line_detection')
 *
 * Maps internal phases to user-facing tooltip translation source strings.
 * These strings must be registered in apps/client/src/translation/questTranslations.ts
 * for the extraction CLI to pick them up.
 */
export const lineDetectionQuest: QuestDefinition = {
  toolName: 'line_detection',
  states: {
    idle: 'brush inside an area',
    manual_idle: 'click to define the shape',
    editing_shape: 'adjust the shape with line prompts or manual line drawing',
    confirm_room: 'click to add more lines or press Enter to confirm',
    editing_room: 'adjust the shape with line prompts or manual line drawing',
    drawing_walls: 'draw lines connected to the shape, press Enter to confirm',
  },
  defaultKey: 'brush inside an area',
  overrides: {
    shift_snap: 'Shift: Snap the line perpendicular to the connected line',
    ctrl_no_snap: 'Ctrl: Move the line without snapping',
    ctrl_refine: 'click on the surface to refine the plane, release Ctrl to apply',
    right_click_delete: 'Right-click drag: Delete multiple lines',
    wall_snap_drag: 'drag to add or remove a rectangular area',
    drag_move: 'drag to move the line',
    right_click_delete_single: 'Right-click: Delete the line',
    edge_op_pick_parallel: 'click a target line to align parallel — shift-click adds to the average, Esc to cancel',
    edge_op_pick_perpendicular: 'click a target line to align perpendicular — shift-click adds to the average, Esc to cancel',
    edge_op_pick_distance: 'click a target line to set the distance — Esc to cancel',
  },
};
